import * as CardCrawl from "@ravalmatic/cardcrawl-engine";
import { Tableau } from "./Tableau";
import { BoardContainer } from "../BoardContainer";
import { GameVars } from "../../../GameVars";
import { PlayerCard } from "../cards/PlayerCard";
import { BoardScene } from "../BoardScene";

export class LowerTableauContainer extends Tableau {

    public slots: Phaser.GameObjects.Image[];

    constructor(scene: Phaser.Scene) {
        
        super(scene);

        this.type = CardCrawl.TableauType.LOWER;
        this.name = CardCrawl.TableauType.LOWER;

        this.highlightFrames[1].setFrame("position_highlight_cut");

        this.slots = [];

        // unos gráficos de tablero temporal
        for (let i = 0; i < 4; i++) {

            let imgName: string;
            let scaleX = 1;

            switch (i) {
                case 0:
                    imgName = "slot-hand";
                    break;
                case 1:
                    continue;
                    break;
                case 2:
                    imgName = "slot-hand";
                    scaleX = -1;
                    break;
                case 3:
                    imgName = "slot-backpack";
                    break;
                default:
            }
            
            const p = this.getCardPosition(i);
                
            const slot = new Phaser.GameObjects.Image(this.scene, p.x, p.y, "texture_atlas_1", imgName);
            slot.angle = p.angle;
            slot.scaleX = scaleX;
            this.addAt(slot, 0);

            this.slots.push(slot);
        }
    }

    public onGameOver(): void {

        this.scene.tweens.add({
            targets: this.slots,
            alpha: 0,
            duration: 400,
            ease: Phaser.Math.Easing.Linear,
            delay: GameVars.victory ? BoardScene.DELAY_GAME_OVER : 0
        });

        const delay = GameVars.victory ? 1250 + BoardScene.DELAY_GAME_OVER : 1250;

        for (let i = 0; i < this.cards.length; i++) {
            
            const card = this.cards[i];

            if (card) {

                const p = this.getCardPosition(1);
                p.y -= 450;

                if (card.cardData.type === CardCrawl.CardType.PLAYER) {

                    const player = <PlayerCard> card;

                    // TODO: VER Q SE HACE ADEMAS DE ESTO
                    this.bringToTop(player);

                    this.scene.tweens.add({
                        targets: player,
                        y: p.y,
                        duration: 800,
                        delay: delay,
                        ease: Phaser.Math.Easing.Cubic.Out
                    });

                    player.hideGlow();
    
                } else {
    
                    this.scene.tweens.add({
                        targets: card,
                        alpha: 0,
                        x: p.x,
                        y: p.y,
                        angle: 0,
                        duration: 800,
                        delay: delay,
                        ease: Phaser.Math.Easing.Cubic.In
                    });
                }
            }
        }
    }

    public showAllowedMoves(card: CardCrawl.CardData): void {
        
        this.highlightFrames.forEach((frame: Phaser.GameObjects.Image, index: number) => {
  
            if (GameVars.allowedMoves.lowerTableau[index]) {
                frame.visible = true;
                frame.setScale(1.1);
                this.scene.tweens.add({
                    targets: frame,
                    scaleX: 1,
                    scaleY: 1,
                    duration: 1000,
                    ease: Phaser.Math.Easing.Cubic.Out,
                    repeat: -1,
                    yoyo: false,
                    loopDelay: 300
                });
            }
        });

        if (this.highlightFrames[1].visible) {
           
            if (card.type === CardCrawl.CardType.ENEMY) {
                this.highlightFrames[1].tint = 0xec0038;
            } else {
                this.highlightFrames[1].tint = 0xFFFFFF;
            }
        }
    }
    
    public getCardPosition(index: number): {x: number, y: number, angle: number} {

        switch (index) {
            case 0:
                return {x: -220, y: 140, angle: -12};
            case 1:
                return {x: 0, y: BoardContainer.CARD_HEIGHT / 2, angle: 0};
            case 2:
                return {x: 220, y: 140, angle: 12};
            case 3:
                return {x: 0, y: 380, angle: 0};
            default:
                throw new Error("Invalid index");
        }
    }
}
